<template>
	<v-navigation-drawer
		:rail="miniBarraLateralSync"
		class="barra-lateral"
		permanent
		>
		<div class="cursor-pointer logo">
			<v-btn
				variant="text"
				color="white"
				:icon="iconeBarraLateral"
				@click.stop="miniBarraLateralSync = !miniBarraLateralSync"
				/>
			<v-img
				v-if="!miniBarraLateralSync"
				:src="logoAplicacao()"
				contain
				class="cursor-pointer logo-img"
				@click="$router.push('/')"
				/>
		</div>
		<Loading
			:show="usuarioLogado === null"
			@click="$router.push('/perfil').catch(()=>{})"
			class="d-flex flex-row cursor-pointer"
			style="min-height: 60px;"
			backgroundOpacity="0"
			spinnerColor="#201F1E"
			:spinnerSize="30"
			>
			<div class="ma-2">
				<v-avatar
					color="primary"
					size="40"
					style="outline: 1px solid var(--primary);"
					>
					<Loading
						:show="usuarioLogado == null"
						backgroundOpacity="0"
						spinnerColor="white"
						:spinnerSize="20"
						>
						<v-img
							v-if="imagemPerfil"
							:src="imagemPerfil || null"
							alt="FotoPerfil"
							:loading="usuarioLogado == null"
							/>
						<span
							v-if="!imagemPerfil && usuarioLogado != null"
							class="white--text font-weight-medium fs-18 lh-18"
							>
							<span v-if="modoDemonstracao">
								US
							</span>
							<span v-else>
								{{buscarIniciais(usuarioLogado.nome)}}
							</span>
						</span>
						<span
							v-else
							class="opacity-0"
							>
							--
						</span>
					</Loading>
				</v-avatar>
			</div>
			<div
				v-if="!miniBarraLateralSync"
				class="ma-2 defaultFontColor--text"
				>
				<div
				class="text-uppercase"
				style="text-overflow: ellipsis;"
				>
					<span v-if="usuarioLogado">
						<span v-if="modoDemonstracao">
							NOME DO USUARIO
						</span>
						<span v-else>
							{{usuarioLogado.nome}}
						</span>
					</span>
				</div>
				<div class="fs-12">
					<span v-if="usuarioLogado">
						<span
							v-if="modoDemonstracao"
							class="opacity-50"
							>
							000.000.000-00
						</span>
						<span v-else>
							{{ formatarCpf(usuarioLogado.cpf) }}
						</span>
					</span>
				</div>
			</div>
		</Loading>
		<div
			v-if="isHomologacaoOuDev() && !modoDemonstracao"
			class="textoHmg"
			>
			<v-icon
				v-if="miniBarraLateralSync"
				color="white"
				class="p-0 m-0"
				size="20"
				>
				mdi-application-brackets-outline
			</v-icon>
			<span v-else>
				{{ textoHmg }}
			</span>
		</div>
		<v-divider
			v-else
			class="mx-4"
			/>
		<v-list
			nav
			dense
			v-if="isNotEmpty(grupos)"
			>
			<template v-for="grupo, index in grupos" :key="index">
				<v-list-group
					v-if="!grupo.esconder && (!miniBarraLateralSync || grupo.aberto)"
					:value="grupo.nome"
					>
					<template v-slot:activator="{ props }">
						<v-list-item
							v-if="!miniBarraLateralSync"
							:base-color="corItemLista"
							v-bind="props"
							:title="grupo.nome"
							/>
						<v-divider v-else/>
					</template>
					<v-list-item
						v-for="item in grupo.items"
						:key="item.nome"
						:to="item.url || undefined"
						:hidden="item.esconder"
						link
						:prepend-icon="item.icone"
						color="black"
						:title="item.nome"
						/>
				</v-list-group>
			</template>
		</v-list>

		<template v-slot:append>
			<v-divider class="mx-4 opacity-0"/>
			<v-list nav dense>
				<v-list-item
					v-if="podeAcessarPainelAdmin"
					link
					class="defaultFontColor--text"
					prepend-icon="mdi-shield-crown"
					:title="textoPainelAdminBarraLateral"
					@click="exibirMenuPainelAdmin()"
					/>
				<v-list-item
					link
					class="defaultFontColor--text"
					prepend-icon="mdi-logout"
					title="Sair"
					@click="logout()"
					/>
			</v-list>
		</template>
	</v-navigation-drawer>
</template>

<script setup>
import { vuetify } from '@/plugins/vuetify'
import { buscarIniciais } from "@/utils/StringUtils.js";
import { isNotEmpty } from "@/utils/ArrayUtils.js";
import { usuarioPossuiPermissao, PERMISSOES_FGTAS } from "@/utils/PermissaoUtils.js";
import Loading from "@/components/commons/loading/Loading.vue";
import { formatarCpf } from "@/utils/CpfUtils.js";
import Logo from "@/assets/logo-fgtas-branca.svg";
import { useRoute } from 'vue-router';
import { onMounted, ref, computed, watch } from 'vue';
import store from '@/store';
import { keycloakLogout } from "@/plugins/authentication.js";

const route = useRoute();

const props = defineProps({
	mini: Boolean
});

const miniBarraLateralSync = ref(false);
const painelAdmin = ref(false);

const usuarioLogado = ref(store.getters["usuario/getUsuarioLogado"]);
const parametros = ref(store.getters["dadosFixos/getParametros"]);

const modoDemonstracao = computed(() => {
	return parametros.value != null && parametros.value.modoDemonstracao;
});

const podeAcessarPainelAdmin = computed(() => {
	return usuarioPossuiPermissao(usuarioLogado.value, PERMISSOES_FGTAS.VISUALIZAR_PAINEL_ADMIN);
});

const textoPainelAdminBarraLateral = computed(() => {
	return painelAdmin.value ? "Sair do Painel do Administrador" : "Painel do Administrador";
});

const imagemPerfil = computed(() => {
	return usuarioLogado.value?.imagemPerfil?.urlPublica || false;
});

const corItemLista = computed(() => {
	return vuetify.theme.current.value.dark ? "white" : "primary";
})

const grupos = computed(() => {
	if(painelAdmin.value){
		return gruposAdmin.value;
	}
	return gruposPublicos.value;
});

const gruposAdmin = computed(() => {
	return [
		{
			nome: "Painel do Administrador",
			aberto: true,
			esconder: !usuarioPossuiPermissao(usuarioLogado.value, PERMISSOES_FGTAS.VISUALIZAR_PAINEL_ADMIN),
			icone: "",
			items: [
				{
					nome: "Acessos",
					url: "/admin/gerenciar-acessos",
					icone: "mdi-key-outline",
					esconder: !usuarioPossuiPermissao(usuarioLogado.value, PERMISSOES_FGTAS.GERENCIAR_ACESSOS),
				},
				{
					nome: "Solicitações de Vagas",
					url: "/admin/vagas/lista",
					icone: "mdi-text-box-search-outline",
					esconder: !usuarioPossuiPermissao(usuarioLogado.value, PERMISSOES_FGTAS.VISUALIZAR_SOLICITACAO_VAGA),
				},
				{
					nome: "Cadastro de Atendimentos",
					url: "/admin/atendimentos",
					icone: "mdi-face-agent",
					esconder: !usuarioPossuiPermissao(usuarioLogado.value, PERMISSOES_FGTAS.CADASTRAR_ATENDIMENTO),
				},
				{
					nome: "Consulta de Atendimentos",
					url: "/admin/consulta-atendimentos/",
					icone: "mdi-text-search-variant",
					esconder: !usuarioPossuiPermissao(usuarioLogado.value, PERMISSOES_FGTAS.VISUALIZAR_ATENDIMENTO),
				},
				{
					nome: "Gerenciar Agências",
					url: "/admin/gerenciar-agencias/",
					icone: "mdi-home-city-outline",
					esconder: !usuarioPossuiPermissao(usuarioLogado.value, PERMISSOES_FGTAS.ACESSO_TOTAL),
				},
			],
		},
	];
});

const iconeBarraLateral = computed(() => {
	if(miniBarraLateralSync.value === null){
		return "mdi-menu";
	}
	return miniBarraLateralSync.value ? "mdi-chevron-double-right" : "mdi-chevron-double-left";
});

const gruposPublicos = computed(() => {
	return [
		{
			nome: "Vagas",
			aberto: true,
			esconder: !usuarioPossuiPermissao(usuarioLogado.value, PERMISSOES_FGTAS.CADASTRAR_VAGA) || !usuarioPossuiPermissao(usuarioLogado.value, PERMISSOES_FGTAS.ACOMPANHAR_VAGA),
			icone: "",
			items: [
				{
					nome: "Home",
					url: "/",
					icone: "mdi-home-outline",
					esconder: true,
				},
				{
					nome: "Cadastro de Vagas",
					url: "/vagas/nova",
					icone: "mdi-file-document-plus-outline",
					esconder: !usuarioPossuiPermissao(usuarioLogado.value, PERMISSOES_FGTAS.CADASTRAR_VAGA),
				},
				{
					nome: "Acompanhar Vagas",
					url: "/vagas/lista",
					icone: "mdi-file-search-outline",
					esconder: !usuarioPossuiPermissao(usuarioLogado.value, PERMISSOES_FGTAS.ACOMPANHAR_VAGA),
				},
			],
		},
	];
});

const textoHmg = computed(() => {
	if(import.meta.env.VITE_PROFILE.toUpperCase() == "HMG"){
		return "Homologação";
	}
	if(import.meta.env.VITE_PROFILE.toUpperCase() == "DEV"){
		return "Desenvolvimento";
	}
	return "";
});

function exibirMenuPainelAdmin(){
	if(podeAcessarPainelAdmin.value){
		painelAdmin.value = !painelAdmin.value;
	}
	else{
		painelAdmin.value = false;
	}
	return
};

function logoAplicacao(){
	return Logo;
}

function logout(){
	keycloakLogout();
};

function sincronizarRotaComPainel(){
	if(podeAcessarPainelAdmin.value){
		for(const grupo of gruposAdmin.value){
			for(const item of grupo.items){
				if(item.url == route.path){
					exibirMenuPainelAdmin();
					return;
				}
			}
		}
		if(route.path.includes("/admin/")){
			exibirMenuPainelAdmin();
			return;
		}
	}
};

function isHomologacaoOuDev(){
	return import.meta.env.VITE_PROFILE.toUpperCase() == "HMG" || import.meta.env.VITE_PROFILE.toUpperCase() == "DEV";
};

onMounted(() => {
	sincronizarRotaComPainel();
});

watch(route, () => {
	if(route.path.includes("/admin") && podeAcessarPainelAdmin.value && !painelAdmin.value){
		exibirMenuPainelAdmin();
	}
});

watch(podeAcessarPainelAdmin.value, () => {
	if(route.path.includes("/admin") && podeAcessarPainelAdmin.value && !painelAdmin.value){
		exibirMenuPainelAdmin();
	}
});
</script>

<style scoped>
.barra-lateral {
	background-color: var(--secondary);
}
.logo{
	display: flex;
	flex-direction: row;
	align-items: center;
	width: 100%;
	/* background-color: red; */
	margin: 0px;
	padding: 0px;
	height: 90px;
	background-color: var(--primary);
}

.logo-col{
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	/* background-color: red; */
	margin: 0px;
	padding: 0px;
	height: 90px;
	background-color: var(--primary);
}

.logo-img{
	max-width: 160px;
}
.textoHmg{
	color: var(--white);
	background-color: var(--primary);
	text-align: center;
	padding: 4px;
}
.v-list-group__items .v-list-item {
	padding: 10px !important;
	min-height: 0 !important;
}

</style>
